import React from "react"
import Plot from "react-plotly.js"
import PropTypes from "prop-types"
import { ReactComponent as GraphIcon } from "../../../assets/icons/graph-icon.svg"
import { Typography } from "@mui/material"

const GraphStatic = ({ labels, c2pData, hiredData, isLoading }) => {
    const emptyLayout = {
        shapes: [
            {
                type: "line",
                x0: 0,
                x1: 1,
                y0: 0.45,
                y1: 0.45,
                xref: "paper",
                yref: "paper",
                line: {
                    color: "#FFFFFF33",
                    width: 1,
                },
            },
            {
                type: "line",
                x0: 0,
                x1: 1,
                y0: 0.55,
                y1: 0.55,
                xref: "paper",
                yref: "paper",
                line: {
                    color: "#FFFFFF33",
                    width: 1,
                },
            },
            {
                type: "line",
                x0: 0,
                x1: 1,
                y0: 0.65,
                y1: 0.65,
                xref: "paper",
                yref: "paper",
                line: {
                    color: "#FFFFFF33",
                    width: 1,
                },
            },
        ],
        paper_bgcolor: "transparent",
        plot_bgcolor: "transparent",
        staticPlot: true,
        hovermode: false,
        margin: { t: 15, b: 32, l: 10, r: 10 },
        width: 297,
        height: 202,
        autosize: false,
        font: {
            color: "#fff",
            size: 16,
        },
        xaxis: {
            showline: true,
            linecolor: "#FFF",
            ticks: "",
            showticklabels: false,
            showgrid: false,
            zeroline: false,
            position: 0.32,
        },
        yaxis: {
            showline: false,
            showticklabels: false,
            showgrid: false,
            zeroline: false,
            ticks: "",
            visible: false,
            range: [0, 1],
        },
    }
    if (isLoading) {
        return (
            <div
                style={{
                    position: "relative",
                    width: "297px",
                    height: "202px",
                }}
            >
                <Plot
                    data={[]}
                    layout={emptyLayout}
                    config={{ staticPlot: true }}
                />
                <div
                    style={{
                        position: "absolute",
                        top: -33,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#fff",
                        fontSize: "18px",
                        fontFamily: "Titillium Web, sans-serif",
                        zIndex: 1,
                        flexDirection: "column",
                    }}
                >
                    <GraphIcon />
                    <Typography variant="textBody" color={"common.white"}>
                        Carregando dados...
                    </Typography>
                </div>
            </div>
        )
    }

    if (
        !c2pData ||
        !hiredData ||
        c2pData.length === 0 ||
        hiredData.length === 0
    ) {
        return (
            <div
                style={{
                    position: "relative",
                    width: "297px",
                    height: "202px",
                }}
            >
                <Plot
                    data={[]}
                    layout={emptyLayout}
                    config={{ staticPlot: true }}
                />
            </div>
        )
    }

    const maxValue = Math.max(...c2pData, ...hiredData)
    const yAxisMax = Math.ceil(maxValue * 1.9)

    const decimalPoint = (value) => value.toLocaleString("pt-BR")

    return (
        <div
            style={{
                width: "297px",
                maxWidth: "297px",
                backgroundColor: "transparent",
                padding: "0",
                fontFamily: "Titillium Web, sans-serif",
                boxSizing: "border-box",
            }}
        >
            <Plot
                data={[
                    {
                        x: labels,
                        y: c2pData,
                        type: "bar",
                        name: "C2P",
                        width: 0.37,
                        marker: {
                            color: [
                                "rgba(43, 206, 149, 1)",
                                "rgba(43, 206, 149, 1)",
                                "rgba(43, 206, 149, 1)",
                            ],
                            line: {
                                width: 0,
                            },
                        },
                        text: c2pData.map(decimalPoint),
                        textposition: "outside",
                        textfont: {
                            size: 16,
                            color: "#fff",
                        },
                    },
                    {
                        x: labels,
                        y: hiredData,
                        type: "bar",
                        name: "CONTRATADO",
                        width: 0.37,
                        marker: {
                            color: [
                                "rgba(224, 29, 29, 1)",
                                "rgba(224, 29, 29, 1)",
                                "rgba(224, 29, 29, 1)",
                            ],
                            line: {
                                width: 0,
                            },
                        },
                        text: hiredData.map(decimalPoint),
                        textposition: "outside",
                        textfont: {
                            size: 16,
                            color: "#fff",
                        },
                    },
                ]}
                layout={{
                    barmode: "group",
                    bargap: 0.2,
                    bargroupgap: 0.59,
                    paper_bgcolor: "transparent",
                    plot_bgcolor: "transparent",
                    staticPlot: true,
                    hovermode: false,
                    margin: { t: 15, b: 0, l: 10, r: 10 },
                    width: 297,
                    height: 202,
                    autosize: false,
                    font: {
                        color: "#fff",
                        size: 16,
                    },
                    xaxis: {
                        tickfont: { size: 16 },
                        linecolor: "#fff",
                        showline: true,
                        zeroline: false,
                        automargin: false,
                        range: [-0.4, 2.4],
                    },
                    yaxis: {
                        showticklabels: false,
                        tickfont: { size: 12, color: "#fff" },
                        showgrid: true,
                        showline: false,
                        gridcolor: "#444",
                        zeroline: false,
                        range: [0, yAxisMax / 1.6],
                        dtick: yAxisMax / 4,
                        tick0: 0,
                        tickmode: "linear",
                        autorange: false,
                    },
                    legend: {
                        font: {
                            size: 14,
                        },
                        itemclick: false,
                        itemdoubleclick: false,
                        orientation: "h",
                        y: -0.45,
                        x: 0.5,
                        xanchor: "center",
                    },
                }}
                config={{ staticPlot: true }}
            />
        </div>
    )
}

GraphStatic.propTypes = {
    labels: PropTypes.arrayOf(PropTypes.string).isRequired,
    c2pData: PropTypes.arrayOf(PropTypes.number).isRequired,
    hiredData: PropTypes.arrayOf(PropTypes.number).isRequired,
    isLoading: PropTypes.bool.isRequired,
}

export default GraphStatic
